import { useApolloClient, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { CLONE_CAMPAIGN, CREATE_CAMPAIGN, UPDATE_CAMPAIGN } from "graphql/campaign/mutation";
import { GET_PROD_CATEGORIES } from "graphql/category/query";
import { converterCategoriesForForm } from "hooks/category/converter";

export const useGetCategoriesOptions = (level) => {
  const { loading, data } = useQuery(GET_PROD_CATEGORIES, {
    variables: { req: { levels: [1] } },
  });

  return {
    loading,
    data: converterCategoriesForForm(data?.category?.list, level),
  };
};

export const useCreateCampaign = () => {
  const client = useApolloClient();
  const [createCampaign, { loading, error, data }] = useMutation(CREATE_CAMPAIGN);

  const handleCreateCampaign = async (params, cloneID) => {
    const res = await createCampaign({
      variables: { promotionCampaignInput: params, cloneID },
    });

    if (res?.data?.promotionCampaign?.create?.promotionID) {
      client.cache.evict({ id: "ROOT_QUERY", fieldName: "promotionCampaign" });
      client.cache.gc();
    }

    return res;
  };
  return {
    handleCreateCampaign,
    loading,
    error,
    data,
  };
};

export const useUpdateCampaign = () => {
  const [updateCampaign, { loading, error, data }] = useMutation(UPDATE_CAMPAIGN);

  const handleUpdateCampaign = async ({ id, params }) => {
    return await updateCampaign({
      variables: {
        id: id,
        promotionCampaignInput: params,
      },
      skip: !params || !params?.id,
    });
  };

  return {
    handleUpdateCampaign,
    loading,
    error,
    data,
  };
};

export const useCloneCampaign = () => {
  const [cloneCampaign, { loading, error, data }] = useMutation(CLONE_CAMPAIGN);

  const handleCloneCampaign = async (id) => {
    return await cloneCampaign({
      variables: { promotionCampaignID: id },
      skip: !id,
    });
  };
  return {
    handleCloneCampaign,
    loading,
    error,
    data,
  };
};

export const useLazyGetCategoriesOptions = (level) => {
  const [pagination, { loading, data }] = useLazyQuery(GET_PROD_CATEGORIES);

  const getDataCategories = async () => {
    pagination({
      variables: { req: { levels: [1] } },
    });
  };

  return {
    loading,
    data: converterCategoriesForForm(data?.category?.list, level),
    getDataCategories,
  };
};
